export const getTenantShortNameFromUrl = (url: string) => {
  return url.split('/')[2];
};
